import { render, staticRenderFns } from "./MostDiscountProduct.vue?vue&type=template&id=1fa888be&scoped=true&"
import script from "./MostDiscountProduct.vue?vue&type=script&lang=js&"
export * from "./MostDiscountProduct.vue?vue&type=script&lang=js&"
import style0 from "./MostDiscountProduct.vue?vue&type=style&index=0&id=1fa888be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa888be",
  null
  
)

export default component.exports